import { render } from "./TargetList.vue?vue&type=template&id=c22fe506"
import script from "./TargetList.vue?vue&type=script&lang=js"
export * from "./TargetList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/containers/event/eventSettings/components/TargetList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c22fe506"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c22fe506', __exports__)) {
    api.reload('c22fe506', __exports__)
  }
  
  module.hot.accept("./TargetList.vue?vue&type=template&id=c22fe506", () => {
    api.rerender('c22fe506', render)
  })

}


export default __exports__